var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table-browser-word-break" }, [
    _vm.alternativeNameSetting.included
      ? _c("div", [
          _vm.item.alternativeNames[_vm.alternativeNameSetting.selected]
            ? _c("div", [
                _c("a", { attrs: { href: _vm.itemUrl } }, [
                  _vm._v(
                    _vm._s(
                      _vm.item.alternativeNames[
                        _vm.alternativeNameSetting.selected
                      ]
                    )
                  ),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(_vm._s(_vm.item.name)),
                  ]),
                ]),
              ])
            : _c("div", [
                _c("a", { attrs: { href: _vm.itemUrl } }, [
                  _vm._v(_vm._s(_vm.item.name)),
                ]),
              ]),
        ])
      : _c("div", [
          _c("a", { attrs: { href: _vm.itemUrl } }, [
            _vm._v(_vm._s(_vm.item.name)),
          ]),
        ]),
    _vm._v(" "),
    _c("div", [
      _c("small", [_vm._v(_vm._s(_vm.item.metadataTypeName))]),
      _vm._v(" "),
      _vm.item.isDraft
        ? _c("p", { staticClass: "text-muted" }, [
            _vm._v("\n            (Draft)\n        "),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }